module.exports = __webpack_public_path__ + "img/bank.b89a4300.png";